<template>
  <div class="content">
    <div class="header_search">
      <div class="topBtn">
        <Button
          class="item"
          icon="ios-download-outline"
          type="primary"
          @click="downloadTemplate"
          >下载模板</Button
        >
        <Button
          class="item"
          icon="ios-download-outline"
          type="primary"
          @click="batchAddCustomer"
          >批量导入</Button
        >
      </div>
      <div style="padding-top: 10px; padding-right: 5px">
        <!-- 查询和其他操作 -->
        <Form ref="formValidate" :model="listQuery" :label-width="80">
          <Row>
            <Col span="4">
              <FormItem
                label="渠道部门"
                class="mb-10"
                prop="enter_department_id"
              >
                <Select
                  v-model="listQuery.enter_department_id"
                  placeholder="请选择部门"
                  @on-change="changeChannel"
                >
                  <Option
                    v-for="item in departmentList"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="3" offect="1">
              <FormItem :label-width="0" class="mb-10" prop="enter_channel_id">
                <Select
                  v-model="listQuery.channel_id"
                  filterable
                  placeholder="请选择渠道"
                >
                  <Option
                    v-for="item in channelList"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>

            <Col span="3">
              <FormItem label="第一渠道" class="mb-10" prop="isone">
                <Select v-model="listQuery.isone" placeholder="请选择第一渠道">
                  <Option
                    v-for="item in changelList"
                    :key="item.id"
                    :value="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>

            <Col span="6">
              <FormItem label="导入时间" class="mb-10">
                <DatePicker
                  type="date"
                  placeholder="请选择导入开始时间"
                  style="width: 45%"
                  :options="startEntryTime"
                  format="yyyy-MM-dd"
                  :value="defaultStartEntryTime"
                  @on-change="startTimeChange($event, 1)"
                ></DatePicker>
                <span> 至 </span>
                <DatePicker
                  type="date"
                  placeholder="请选择导入结束时间"
                  style="width: 45%"
                  :options="endEntryTime"
                  format="yyyy-MM-dd"
                  :value="defaultEndEntryTime"
                  @on-change="endTimeChange($event, 1)"
                ></DatePicker>
              </FormItem>
            </Col>

            <Col span="6" class="opertionBtn_search">
              <Button
                class="item"
                type="primary"
                icon="ios-search"
                @click="searchList"
                >查询</Button
              >
              <Button class="item" @click="emptyFilter" style="display: none"
                >清空筛选</Button
              >
              <Button
                class="item"
                type="text"
                style="color: #2d8cf0; display: none"
                @click="handleShowOtherSearch"
                >{{ showOtherSearch ? "收起" : "更多筛选" }}</Button
              >
              <FormItem
                style="margin-bottom: 0; display: none"
                :label-width="0"
              >
                <autoTableItem
                  type="batchCustomer"
                  :defaultTable="defaultTable"
                  :autoTableData="autoTableData"
                  placeholder="表格展示项"
                  @autoTableRef="autoTableRef"
                ></autoTableItem>
              </FormItem>
            </Col>
          </Row>
          <Row v-if="showOtherSearch">
            <Checkbox
              v-model="firstEnterStatus"
              @on-change="searchFirstTime"
              style="margin-left: 15px; margin-bottom: 10px"
              >仅查询首次录入时间</Checkbox
            >
          </Row>
        </Form>
      </div>
    </div>

    <Modal
      v-model="showBatchAdd"
      :closable="false"
      :mask-closable="false"
      class-name="vertical-center-modal"
    >
      <p slot="header" class="modal_title">
        <span>批量导入</span>
      </p>
      <Form ref="batchAddForm" :model="uploadParams" :label-width="80">
        <Row>
          <Col span="8">
            <FormItem label="渠道部门" class="mb-10" prop="enter_department_id">
              <Select
                v-model="uploadParams.department_id"
                placeholder="请选择部门"
                @on-change="changeChannel"
              >
                <Option
                  v-for="item in departmentList"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="8" offset="1">
            <FormItem :label-width="0" class="mb-10" prop="enter_channel_id">
              <Select
                v-model="uploadParams.channel_id"
                filterable
                placeholder="请选择渠道"
              >
                <Option
                  v-for="item in channelList"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8" offset="1">
            <Upload
              style="display: inline-block"
              ref="upload"
              :action="uploadUrl"
              :data="uploadParams"
              :headers="uploadHeaders"
              name="excel"
              :show-upload-list="false"
              :on-format-error="handleFormatError"
              :on-success="handleSuccess"
              :on-error="handleError"
              :format="['xlsx', 'xls']"
            >
              <Button width="100%" icon="ios-arrow-round-up" type="primary"
                >选择文件并导入</Button
              >
            </Upload>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <!-- <Button
            type="primary"
            size="large"
            @click.prevent.native="handleSubmit('addChannelForm', isTitle)"
            >确定</Button
          >-->
        <Button size="large" @click="handleReset('batchAddForm')">取消</Button>
      </div>
    </Modal>

    <Modal
      v-model="showEditUser"
      :closable="false"
      :mask-closable="false"
      class-name="vertical-center-modal"
    >
      <p slot="header" class="modal_title">
        <span>编辑用户</span>
      </p>
      <Form
        ref="editMemberForm"
        :rules="ruleValidate"
        :model="userData"
        :label-width="100"
      >
        <Row>
          <Col span="12">
            <FormItem label="姓名" class="mb-10" prop="name">
              <Input v-model="userData.name" placeholder="请输入"></Input>
            </FormItem> </Col
        ></Row>
        <Row>
          <Col span="16">
            <FormItem label="手机号" class="mb-10" prop="phone">
              <Input
                v-model="userData.phone"
                required
                :maxlength="11"
                placeholder="请输入"
              ></Input>
            </FormItem> </Col
        ></Row>
        <Row>
          <Col span="12">
            <FormItem label="用户分组" class="mb-10" prop="member_group_id">
              <Select
                v-model="userData.member_group_id"
                placeholder="请选择部门"
              >
                <Option
                  v-for="item in customerGroudList"
                  :key="item.id"
                  :value="item.id"
                  >{{ item.name }}</Option
                >
              </Select>
            </FormItem>
          </Col></Row
        >
        <Row>
          <Col span="12">
            <FormItem label="性别" class="mb-10" prop="sex">
              <RadioGroup v-model="userData.sex">
                <Radio label="1">男</Radio>
                <Radio label="2">女</Radio>
              </RadioGroup>
            </FormItem></Col
          ></Row
        >
        <Row>
          <Col span="12">
            <FormItem label="咨询日期" class="mb-10" prop="consult_time">
              <DatePicker
                type="date"
                placeholder="请选择"
                style="display: block"
                :transfer="true"
                v-model="userData.consult_time"
              ></DatePicker>
            </FormItem> </Col
        ></Row>
        <Row>
          <Col span="12">
            <FormItem label="预产期" class="mb-10" prop="child_birth">
              <DatePicker
                type="date"
                placeholder="请选择"
                style="display: block"
                :transfer="true"
                v-model="userData.child_birth"
              ></DatePicker> </FormItem></Col
        ></Row>

        <FormItem label="备注" class="mb-10" prop="remark">
          <Input
            v-model="userData.remark"
            type="textarea"
            :maxlength="500"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="500字(含)以内"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button
          type="primary"
          size="large"
          @click="handleSubmit('editMemberForm')"
          >确定</Button
        >
        <Button size="large" @click="handleReset('editMemberForm')"
          >取消</Button
        >
      </div>
    </Modal>

    <div class="table_wrap">
      <div class="table_tip">
        <Button size="small" type="primary" @click="addBatchMember"
          >批量录入</Button
        >
      </div>
      <div style="width: 100%">
        <!--   :width="tableWidth" -->
        <Table
          stripe
          border
          ref="table"
          @on-selection-change="batchAdd"
          :columns="tabColumns"
          :loading="tabLoading"
          :data="tabData"
          class="table_style"
          :height="tableHeight"
        ></Table>
        <div style="margin-top: 20px; display: flex; justify-content: flex-end">
          <Page
            show-total
            show-elevator
            show-sizer
            :page-size-opts="pageSizeOpts"
            :page-size="50"
            :transfer="true"
            :total="total"
            :current="listQuery.page"
            @on-change="changePage"
            @on-page-size-change="changeLimit"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import autoTableItem from "@/commonTmp/CRM/CRM_autoTableItem"; //表格自选项
import dropCheckBox from "@/commonTmp/dropCheckBox"; //多选下拉框
import customerExcel from "@/commonTmp/CRM/CRM_customerExcel"; //客户导出
import userAccessRecord from "@/commonTmp/CRM/CustomerManagementTmp/userAccessRecord"; //用户回访记录
export default {
  name: "batchCustomer",
  components: {
    autoTableItem,
    dropCheckBox,
    customerExcel,
    userAccessRecord,
  },
  data() {
    return {
      defaultStartEntryTime: util.getPreDate(120),
      defaultEndEntryTime: util.getPreDate(0),
      excelTitle: "",
      excelSteps: 1,
      downloadLink: "",
      userId: "",
      showBatchAdd: false,
      uploadUrl: api.batchImport,
      uploadHeaders: {
        Authorization: "",
      },
      defaultTable: [
        "id",
        "name",
        "phone",
        "store_name",
        "member_group_name",
        "sex_text",
        "child_birth",
        "consult_time",
        "channel_name",
        "remark",
        "agent",
        "created_at",
      ],
      changelList: [
        {
          id: 0,
          name: "全部",
        },
        {
          id: 1,
          name: "是",
        },
        {
          id: 2,
          name: "否",
        },
      ],
      ruleValidate: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        channel_id: [{ required: true, message: "请输入", trigger: "change" }],
        phone: [
          {
            required: true,
            min: 11,
            message: "手机号格式错误",
            trigger: "blur",
          },
        ],
        member_group_id:{ required: true,   type: 'number',  message: '请选择', trigger: 'change' },
        consult_time:{ required: true,   type: 'date',  message: '请选择', trigger: 'change' },
        remark: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      autoTableData: [
        {
          name: "id",
          id: "id",
          disabled: true,
        },
        {
          name: "姓名",
          id: "name",
          disabled: true,
        },
        {
          name: "手机号",
          id: "phone",
          disabled: true,
        },
        {
          name: "跟进门店",
          id: "store_name",
          disabled: true,
        },
        {
          name: "本门店分组",
          id: "member_group_name",
          disabled: false,
        },
        {
          name: "性别",
          id: "sex_text",
          disabled: true,
        },
        {
          name: "预产日期",
          id: "child_birth",
          disabled: true,
        },
        {
          name: "咨询日期",
          id: "consult_time",
          disabled: true,
        },
        {
          name: "渠道",
          id: "channel_name",
          disabled: true,
        },
        {
          name: "备注",
          id: "remark",
          disabled: true,
        },
        {
          name: "录入人员",
          id: "agent",
          disabled: true,
        },
        {
          name: "录入时间",
          id: "created_at",
          disabled: true,
        },
      ],
      baseData: baseData,
      customerExcelShow: false,
      storeList: [],
      customerGroudList: [],
      departmentList: [],
      channelList: [],
      channelAddList: [],
      followrList: [],
      followrAddList: [],
      followrBatchAddList: [],
      followDepartmentList: [],
      enter_department_id: "", //渠道部门id
      checkedShowValue: "",
      signStoreCheckedShowValue: "",

      tabLoading: false,
      tableHeight: 500,
      tableWidth: 1000,
      tabData: [],
      tabColumns: [],
      showOtherSearch: false,
      showBatchAddWithPeople: false,
      loading: false,
      uploadParams: {
        channel_id: "",
        department_id: "",
      },
      userData: {
        channel_id: undefined,
        child_birth: undefined,
        consult_time: undefined,
        department_id: undefined,
        id: undefined,
        member_group_id: "",
        name: undefined,
        phone: undefined,
        remark: undefined,
        sex: undefined,
      },
      addBatchMemberForm: {
        ids: [],
        store_id: "",
      },
      //导出Excel
      listQueryExcel: {},
      // 列表查询参数
      listQuery: {
        page: 1,
        limit: 50,
        channel_id: "",
        // list_type:1,//连锁客户
        first_enter_id: "", //仅查询首次录入时间
        store_id: [],
        keywords: "",
        enter_channel_id: "",
        enter_agent: "",
        enter_department_id: "",
        isone: "",
        member_group: [],
        member_type_id: "",
        start_time: "",
        end_time: "",
        agent_time_start: "",
        agent_time_end: "",
        follow_store_id: "",
        follow_department_id: "",
        follow_agent_id: "",
        channel_name_id: "",
        insert_way_id: "",
        chankang_type: "",
        id: "",
        sort: {},
      },

      firstEnterStatus: false,
      total: 0,
      pageSizeOpts: [50, 60, 70, 80, 90, 100],
      columnsAll: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "ID",
          key: "id",
          align: "center",
          // width:100,
          // fixed: 'left'
        },
        {
          title: "姓名",
          key: "name",
          align: "center",
          // width:100,
          // fixed: 'left'
        },
        {
          title: "性别",
          key: "sex_text",
          align: "center",
          // width:70
        },
        {
          title: "手机号",
          align: "center",
          key: "phone",
          width: 140,
          render: (h, params) => {
            const row = params.row;
            const text = row.phone;
            return h("div", [
              h("span", { style: { textAlign: "center" } }, text),
              h("Button", {
                props: {
                  type: "text",
                  icon: "ios-paper-outline",
                },
                style: {},
                on: {
                  click: () => {
                    this.copy(text);
                  },
                },
              }),
            ]);
          },
        },
        {
          title: "跟进门店",
          key: "store_name",
          align: "center",
        },
        {
          title: "本门店分组",
          key: "member_group_name",
          align: "center",
          // width:180,
        },
        {
          title: "性别",
          align: "center",
          key: "sex_text",
          // width:180,
        },
        {
          title: "预产期",
          align: "center",
          key: "child_birth",
          // width:180,
        },
        {
          title: "咨询日期",
          align: "center",
          key: "consult_time",
          // width:180,
        },
        {
          title: "渠道",
          align: "center",
          key: "channel_name",
        },
        {
          title: "备注",
          align: "center",
          key: "remark",
        },
        {
          title: "导入时间",
          align: "center",
          key: "created_at",
        },
        {
          title: "导入人员",
          align: "center",
          key: "agent",
        },
        {
          title: "操作",
          width: 170,
          align: "center",
          // fixed: 'right',
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      // this.userId = params.row.id.toString();

                      this.getImportMemberDetail(params.row.id.toString());

                      // this.showEditUser = true;
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.apiMemberInput(params.row.id.toString());
                    },
                  },
                },
                "录入"
              ),
              h(
                "Button",
                {
                  props: {
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.apiMemberDel(params.row.id.toString());
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      startEntryTime: {}, //开始日期设置
      endEntryTime: {}, //结束日期设置
      startDistributionTime: {}, //开始日期设置
      endDistributionTime: {}, //结束日期设置

      // ************ 回访信息 ************
      showAccessInfo: false,
      accessInfoType: "all",
      isModalTitle: 1,
      stylesModal: {
        height: "500px",
      },
      // ************ 客户详情 ************
      showEditUser: false,
    };
  },
  created() {
    if (window.agent_info) {
      this.addBatchMemberForm.store_id = window.agent_info.store_id;
      this.uploadHeaders.Authorization = window.token_type + " " + window.token;
    }

    if (Lockr.get("batchCustomer"))
      this.defaultTable = Lockr.get("batchCustomer");
    this.listQuery.start_time = this.dateFormat(
      Date.parse(this.defaultStartEntryTime)
    );
    this.listQuery.end_time = this.dateFormat(
      Date.parse(this.defaultEndEntryTime)
    );
    console.log(this.listQuery.start_time);
    console.log(this.listQuery.end_time);
    this.getList("init");

    // this.apiDepartmentAll();
  },
  mounted() {
    this.tableHeight =
      window.innerHeight - this.$refs.table.$el.offsetTop - 220;
    this.tableWidth = window.innerWidth - 270;
  },
  methods: {
    downloadTemplate() {
      window.open("static/user-template.xlsx", "_blank");
    },
    Close() {
      this.showAccessInfo = false;
    },
    addBatchMember() {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确定要批量录入吗？</p>",
        onOk: () => {
          if (this.addBatchMemberForm.ids.length != 0) {
            console.log("=======>", this.addBatchMemberForm.ids.join(","));
            this.loading = true;
            serve
              .fetchGet(api.memberInput, {
                id: this.addBatchMemberForm.ids.join(","),
              })
              .then((data) => {
                this.$Message.success("批量录入成功");
                this.getList();
                this.loading = false;
              });
          } else {
            this.$Message.warning("请勾选用户");
          }
        },
      });
    },
    batchAddCustomer() {
      this.showBatchAdd = true;
    },
    //监听表格自选
    autoTableRef(data) {
      Lockr.set("batchCustomer", data);
      let getTableHead = [this.columnsAll[0], this.columnsAll[1]];
      for (let item of data) {
        switch (item) {
          case "name":
            getTableHead.push(this.columnsAll[2]);
            break;
          case "sex_text":
            getTableHead.push(this.columnsAll[3]);
            break;
          case "phone":
            getTableHead.push(this.columnsAll[4]);
            break;
          case "store_name":
            getTableHead.push(this.columnsAll[5]);
            break;
          case "member_group_name":
            getTableHead.push(this.columnsAll[6]);
            break;
          case "sex_text":
            getTableHead.push(this.columnsAll[7]);
            break;
          case "child_birth":
            getTableHead.push(this.columnsAll[8]);
            break;
          case "consult_time":
            getTableHead.push(this.columnsAll[9]);
            break;
          case "channel_name":
            getTableHead.push(this.columnsAll[10]);
            break;
          case "remark":
            getTableHead.push(this.columnsAll[11]);
            break;
          case "created_at":
            getTableHead.push(this.columnsAll[12]);
            break;
          case "agent":
            getTableHead.push(this.columnsAll[13]);
            break;
        }
      }
      getTableHead.push(this.columnsAll[14]);
      this.tabColumns = getTableHead;
    },

    apiMemberInput(ids) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确定要录入吗？</p>",
        onOk: () => {
          this.loading = true;
          serve
            .fetchGet(api.memberInput, {
              id: ids,
            })
            .then((data) => {
              this.$Message.success("录入成功");
              this.getList();
              this.loading = false;
            });
        },
      });
    },
    apiMemberDel(ids) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>确定要删除吗？</p>",
        onOk: () => {
          this.loading = true;
          serve
            .fetchGet(api.memberDel, {
              id: ids,
            })
            .then((data) => {
              this.$Message.success("删除成功");
              this.getList();
              this.loading = false;
            });
        },
      });
    },
    // // 门店
    // apiStoreAll() {
    //   serve
    //     .fetchGet(api.allMemberStoreAll, {})
    //     .then((data) => {
    //       console.log("门店1", data.data);
    //       this.storeList = data.data;
    //       var store_ids = [];
    //       var store_name = "";
    //       for (var i = 0; i < data.data.length; i++) {
    //         store_ids.push(data.data[i].id);
    //         if (i < data.data.length - 1) {
    //           store_name += data.data[i].name + ",";
    //         } else {
    //           store_name += data.data[i].name;
    //         }
    //       }
    //       this.listQuery.store_id = store_ids;
    //       this.signStoreCheckedShowValue = store_name;
    //     })
    //     .catch((error) => {
    //       this.$Message.error(error.response.data.message);
    //     });
    // },
    // 客户分组
    apiGetMemberGroupList() {
      serve
        .fetchGet(api.getMemberGroupList, {})
        .then((data) => {
          this.customerGroudList = data.member_groups;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    getImportMemberDetail(id) {
      let params = {};
      params.id = id;
      serve.fetchGet(api.getImportMemberDetail, params).then((response) => {
        this.showEditUser = true;
        this.userData = response.member;
        this.userData.sex = this.userData.sex.toString();
      });
    },
    //渠道部门
    apiDepartmentAll(store_id) {
      let params = {};
      if (store_id) {
        params.store_id = store_id;
      }
      serve
        .fetchGet(api.getDepartmentList, params)
        .then((data) => {
          if (store_id) {
            this.followDepartmentList = data.data;
          } else {
            this.departmentList = data.data;
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //渠道
    apiChannelAll(id, type = 1) {
      serve
        .fetchGet(api.getChannelList, { department_id: id })
        .then((data) => {
          if (type == 1) {
            this.channelList = data.data;
          } else {
            this.channelAddList = data.data;
          }
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    handleFormatError(file) {
      console.log("文件格式验证失败时");
      this.$Notice.warning({
        title: "文件格式不正确",
        desc: "文件 " + file.name + " 格式不正确，请上传.xls,.xlsx文件。",
      });
    },
    apiMemberEdit() {
      this.loading = true;
      this.userData.consult_time = util.dateFormat(this.userData.consult_time);
      this.userData.child_birth = util.dateFormat(this.userData.child_birth);
      serve.fetchPost(api.memberEdit, this.userData).then((response) => {
        this.$Message.success("编辑成功");
        this.getList();
        this.loading = false;
        this.showEditUser = false;
      });
    },
    // 获取列表
    getList(init) {
      this.tabLoading = true;
      // console.log('请求参数',this.listQuery)
      this.listQueryExcel = JSON.parse(JSON.stringify(this.listQuery));

      serve
        .fetchGet(api.getMemberList, this.listQuery)
        .then((res) => {
          var data = res.data;

          this.tabData = data;
          this.total = res.meta.pagination.total;
          this.tabLoading = false;
          if (init == "init") {
            // this.apiStoreAll();
            this.apiGetMemberGroupList();
            this.apiDepartmentAll();
          }
        })
        .catch((error) => {
          this.tabLoading = false;
          this.$Message.error(error.response.data.message);
        });
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    changeChannel(id) {
      console.log("id=====>", id);
      // this.listQuery.channel_id = "";
      this.apiChannelAll(id);
    },
    changeDepartment(id) {
      this.listQuery.follow_department_id = "";
      this.listQuery.follow_agent_id = "";
      this.apiDepartmentAll(id);
    },

    changePage(val) {
      this.listQuery.page = val;
      this.getList();
    },
    changeLimit(val) {
      this.listQuery.page = 1;
      this.listQuery.limit = val;
      this.getList();
    },
    isEditorOk() {
      this.showEditUser = false;
      this.getList();
    },
    searchFirstTime(status) {
      if (status) {
        this.listQuery.first_enter_id = "1";
        this.firstEnterStatus = true;
      } else {
        this.listQuery.first_enter_id = "";
        this.firstEnterStatus = false;
      }
    },
    //监听客户分组
    member_group_even(data, val) {
      this.listQuery.member_group = data;
      this.checkedShowValue = val;
    },

    handleSuccess(res, file) {
      console.log("文件上传成功时", res);
      if (res.code === 0) {
        // this.dialoLead = false
        this.$Message.success("数据导入成功！");
        this.getList();
        this.showBatchAdd = false;
        // this._getBookList()
        // this.$refs.upload.clearFiles()
      } else {
        this.$Message.error(res.msg);
      }
    },
    // 文件上传失败
    handleError(error, file) {
      console.log("文件上传失败时error", error);
      console.log("文件上传失败时file", file);
      this.$Modal.warning({
        width: "600",
        title: "数据导入有误",
        content: file.message,
      });
    },
    batchAdd(data) {
      var arr = [];
      if (data.length) {
        for (var i = 0; i < data.length; i++) {
          arr.push(data[i].id);
        }
      }
      this.addBatchMemberForm.ids = arr;
    },
    handleShowOtherSearch() {
      if (this.showOtherSearch) {
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 120;
      } else {
        this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 350;
      }
      this.showOtherSearch = !this.showOtherSearch;
    },
    // 清空筛选
    emptyFilter() {
      this.defaultEndEntryTime = "";
      this.defaultStartEntryTime = "";
      this.listQuery.page = 1;
      // this.listQuery.store_id = [];
      // this.signStoreCheckedShowValue = "";
      // this.listQuery.keywords = "";
      // this.listQuery.enter_agent = "";
      // this.listQuery.enter_department_id = "";
      // this.listQuery.enter_channel_id = "";
      // this.listQuery.member_group = [];
      this.checkedShowValue = "";
      // this.listQuery.member_type_id = "";
      this.listQuery.start_time = "";
      this.listQuery.end_time = "";
      // this.listQuery.agent_time_start = "";
      // this.listQuery.agent_time_end = "";
      // this.listQuery.follow_store_id = "";
      // this.listQuery.follow_department_id = "";
      // this.listQuery.follow_agent_id = "";
      // this.listQuery.channel_name_id = "";
      // this.listQuery.insert_way_id = "";
      // this.listQuery.first_enter_id = "";
      this.firstEnterStatus = false;
      // this.listQuery.sort = {};
      // this.listQuery.chankang_type = "";
      this.getList();
    },
    // 查询
    searchList() {
      this.listQuery.page = 1;
      this.getList();
    },
    // 复制
    copy(copyInfo) {
      let oInput = document.createElement("input");
      oInput.value = copyInfo;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.style.display = "none";
      document.body.removeChild(oInput);
      this.$Message.success("复制成功");
    },

    // 确认
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          switch (name) {
            case "editMemberForm":
              if (!/^1[3456789]\d{9}$/.test(this.userData.phone)) {
                this.$Message.warning("手机号格式错误");
                return;
              }

              this.apiMemberEdit();
              break;
          }
        } else {
          this.$Message.error("请完善表单");
        }
      });
    },
    // 取消
    handleReset(name) {
      this.$refs[name].resetFields();
      switch (name) {
        case "batchAddForm":
          this.showBatchAdd = false;

          this.uploadParams.channel_id = "";
          this.uploadParams.department_id = "";

          break;
        case "editMemberForm":
          this.showEditUser = false;

          break;
      }
    },
    //限制结束时间
    startTimeChange(e, index) {
      switch (index) {
        case 1:
          this.listQuery.start_time = e;
          var startTime = this.listQuery.start_time
            ? new Date(this.listQuery.start_time).valueOf() -
              1 * 24 * 60 * 60 * 1000
            : "";
          this.endEntryTime = {
            disabledDate: (date) => {
              return date && date.valueOf() < startTime;
            },
          };
          break;
        case 2:
          this.listQuery.agent_time_start = e;
          var startTime = this.listQuery.agent_time_start
            ? new Date(this.listQuery.agent_time_start).valueOf() -
              1 * 24 * 60 * 60 * 1000
            : "";
          this.endDistributionTime = {
            disabledDate: (date) => {
              return date && date.valueOf() < startTime;
            },
          };
          break;
      }
    },
    //限制开始时间
    endTimeChange(e, index) {
      switch (index) {
        case 1:
          this.listQuery.end_time = e;
          var startTime = this.listQuery.end_time
            ? new Date(this.listQuery.end_time).valueOf()
            : new Date();
          this.startEntryTime = {
            disabledDate: (date) => {
              return date && date.valueOf() > startTime;
            },
          };
          break;
        case 2:
          this.listQuery.agent_time_end = e;
          var startTime = this.listQuery.agent_time_end
            ? new Date(this.listQuery.agent_time_end).valueOf()
            : new Date();
          this.startDistributionTime = {
            disabledDate: (date) => {
              return date && date.valueOf() > startTime;
            },
          };
          break;
      }
    },
    //时间格式化
    dateFormat(time) {
      var date = new Date(time);
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return year + "-" + month + "-" + day;
    },

    customerExcelEven(val, is_export, params, title) {
      this.customerExcelShow = val;
      if (is_export) {
        if (title == "导出客户Excel") {
          if (params.value == 1) {
            let listQueryExcel = this.listQueryExcel;
            listQueryExcel.email = params.mail;
            listQueryExcel.channel_info_sort = params.channel_info_sort;
            this.getUserListExcel(listQueryExcel);
            return;
          }
          if (params.value == 2) {
            this.getUserListExcel({
              email: params.mail,
              channel_info_sort: params.channel_info_sort,
            });
          }
          return;
        }
        if (title == "导出回访记录") {
          // this.getUserAccessListExcel({email:params.mail})
          if (params.value == 1) {
            let listQueryExcel = this.listQueryExcel;
            listQueryExcel.email = params.mail;
            this.getUserAccessListExcel(listQueryExcel);
            return;
          }
          if (params.value == 2) {
            this.getUserAccessListExcel({ email: params.mail });
          }
        }
      }
    },
  },
};
</script>
<style scope>
.mr-t-10 {
  margin-top: 10px;
}
.search_bar {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}
.search_bar_item {
  margin: 4px;
}
.other_search_bar {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}

.table_wrap {
  margin: 12px 12px 12px 0px;
}
.ivu-btn-icon-only {
  margin-left: 4px;
  padding: 0px !important;
  font-size: 18px !important;
}
.ivu-table-cell {
  white-space: pre-line !important;
}
.ivu-drawer-header-inner {
  font-size: 20px !important;
}
.table_tip {
  height: 24px;
  margin: 0 0 10px 0px;
}
.demo-drawer-footer {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
  z-index: 10;
}
.user_info_wrap {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  height: 40px;
  color: #464c5b;
  font-weight: 600;
  font-size: 14px;
  line-height: 40px;
  background: #f8f8f9;
  margin: 10px 0;
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.vertical-center-modal .ivu-modal {
  top: 0;
}
.modal_title {
  text-align: center;
}
.modal_text {
  color: red;
  text-align: center;
  margin-bottom: 16px;
}
.user_info_text_wrap {
  height: 46px;
  padding-top: 10px;
  padding-left: 32px;
  /* line-height: 56px; */

  /* padding: 10px; */
}
.opertionBtn {
  margin-bottom: 20px;
  display: flex !important;
  display: -webkit-flex !important;
  align-items: center;
}
.ivu-form-item-error-tip {
  z-index: 9999;
}
.opertionBtn .item {
  margin-right: 5px;
}
.mb-10 {
  margin-bottom: 10px;
}
.mb-20 {
  margin-bottom: 20px;
}
.TimelineItemTime {
  font-size: 14px;
  font-weight: bold;
}
.TimelineItemContent {
  padding-left: 5px;
}
.topBtn {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 10px;
  border-bottom: 1px solid #e8eaec;
  padding-top: 10px;
  padding-right: 5px;
  background: rgba(249, 249, 249);
}
.topBtn .item {
  margin-left: 5px;
}
.header_search {
  border: 1px solid #e8eaec;
}
.opertionBtn_search {
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.opertionBtn_search .item {
  margin-right: 5px;
}
.table_style .ivu-table-cell {
  padding-left: 2px;
  padding-right: 2px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Crm/UserManagement/batchCustomer.vue